module.exports = __webpack_public_path__ + "static/media/depositSlide1.2217b58d.svg";